/*
  Lahtref — busca própria (substitui o XCloud Search)
  1. Corrige erros de digitação frequentes (dados reais de busca, 90 dias).
  2. Atalhos: buscas de intenção clara vão direto para a página certa.
  3. Busca preditiva restrita a título, tipo, variante e tag (menos ruído),
     com produtos esgotados por último.
  4. Chips "Mais buscados" na gaveta de busca.
  5. Garante que todo formulário de busca use a busca nativa (/search).
  6. Banner escrito na gaveta que troca sozinho pela data (campanha -> padrão).
  7. Filtro guiado "Encontre seu modelo" (Grau/Sol, rosto, formato, estilo,
     faixa de desconto durante a campanha) com contagem ao vivo.
  8. Palavras-chave consultivas: "rosto redondo", "leve", "vintage"... viram a
     coleção já filtrada (mesmos parâmetros dos Filtros Lahtref).
  Teste de datas no preview: acrescente ?lah_data=2026-12-01 ao endereço.
*/
(function () {
  if (window.__lahBusca) return;
  window.__lahBusca = true;

  var rotas = (window.themeVariables && window.themeVariables.routes) || {};
  var URL_BUSCA = rotas.searchUrl || '/search';
  var URL_SUGESTAO = rotas.predictiveSearchUrl || '/search/suggest';

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Correções por palavra (erros reais vistos na busca) */
  var PALAVRAS = {
    fredie: 'freddie', fredy: 'freddie', freddy: 'freddie', fred: 'freddie', fredi: 'freddie',
    thay: 'thai', thaii: 'thai',
    sassue: 'sasue', sasuke: 'sasue', sassu: 'sasue', sasu: 'sasue',
    otto: 'oto', lacco: 'laco', theo: 'teo', izo: 'izu',
    paje: 'page', paige: 'page', kpra: 'kora', korra: 'kora', niar: 'nian',
    jab: 'jan', dox: 'doc', nino7: 'nino', keka: 'keca', kekka: 'keca',
    jhon: 'john', jonh: 'john', jon: 'john', brain: 'brian', bryan: 'brian',
    monsa: 'monza', sato: 'satho', satoh: 'satho', neal: 'neil', anpha: 'anpa',
    zenno: 'zeno', okla: 'ocla', ocka: 'ocla', wenn: 'wen', keyko: 'keiko', keico: 'keiko',
    /* erros de digitação dos CSVs do XCloud (out-nov/26), só para modelos que existem */
    tom: 'ton', tonn: 'ton', toni: 'ton', ler: 'lee', leeh: 'lee', leew: 'lee',
    leca: 'laco', lavo: 'laco', lavco: 'laco', laaco: 'laco', lcaco: 'laco',
    anoa: 'anpa', ampa: 'anpa', anap: 'anpa', anpq: 'anpa', anmpa: 'anpa', anpar: 'anpa',
    olca: 'ocla', cola: 'ocla', oclq: 'ocla', ocls: 'ocla', olle: 'ole',
    tai: 'thai', thau: 'thai', thsi: 'thai', tgai: 'thai', tahi: 'thai', thaiu: 'thai',
    niam: 'nian', nyam: 'nian', nuan: 'nian', niqn: 'nian',
    sath: 'satho', saht: 'satho', sahto: 'satho', sathor: 'satho', datho: 'satho',
    oti: 'oto', zeni: 'zeno', zemo: 'zeno', zebo: 'zeno',
    aiboo: 'aibo', aivo: 'aibo', aino: 'aibo', isu: 'izu', ixu: 'izu', izy: 'izu', izzy: 'izu',
    keik: 'keiko', keilo: 'keiko', keco: 'keca', kecq: 'keca', heca: 'keca',
    biran: 'brian', bruan: 'brian', freeddie: 'freddie', freddi: 'freddie', fredd: 'freddie',
    nini: 'nino', niri: 'niro', nril: 'niro', nuro: 'niro', pagem: 'page',
    monxa: 'monza', minza: 'monza', konza: 'monza',
    /* cores: o catálogo usa Ouro, Prata, Tortoise e Musgo (o verde da loja) */
    dourado: 'ouro', dourada: 'ouro', dourados: 'ouro', prateado: 'prata', prateada: 'prata',
    tartaruga: 'tortoise', tartarugado: 'tortoise', oncinha: 'tortoise', tortoiseshell: 'tortoise',
    toroisell: 'tortoise', toroisel: 'tortoise', torois: 'tortoise', tourtoise: 'tortoise', tortoiese: 'tortoise', tortuise: 'tortoise',
    bugio: 'buio', verde: 'musgo', axul: 'azul',
    /* formatos sem filtro próprio: "hexagonal" é o que a loja marca como Geométrico (dado XCloud, out-nov/26) */
    hexagonal: 'geometrico', hexagonais: 'geometrico', hexag: 'geometrico', hexa: 'geometrico', hexago: 'geometrico', hexagon: 'geometrico', hexagona: 'geometrico',
    octogonal: 'geometrico', octogonak: 'geometrico', poligonal: 'geometrico', geometrica: 'geometrico'
  };

  /* Correções de frase inteira */
  var FRASES = {
    'clip on': 'clip-on', 'clipon': 'clip-on', 'clipp on': 'clip-on', 'clip': 'clip-on',
    'clips': 'clip-on', 'clipe': 'clip-on', 'clip ons': 'clip-on', 'clip-on': 'clip-on',
    /* digitação parcial muito comum no XCloud ("cli" 28x/mês, "clippon", "cli pn") */
    'cli': 'clip-on', 'clip o': 'clip-on', 'clippon': 'clip-on', 'cli pn': 'clip-on', 'clipom': 'clip-on',
    'clipo': 'clip-on', 'clipi': 'clip-on', 'clipin': 'clip-on', 'clipn': 'clip-on', 'clion': 'clip-on', 'clio': 'clip-on',
    'clipa': 'clip-on', 'clipan': 'clip-on', 'xlip': 'clip-on', 'clup': 'clip-on', 'clipp': 'clip-on', 'clp': 'clip-on',
    /* "2 em 1" = armação de grau que vira óculos de sol: é o clip-on */
    '2 em 1': 'clip-on', 'oculos de grau 2 em 1': 'clip-on', 'oculos 2 em 1': 'clip-on',
    'torrou se': 'tortoise', 'verde oliva': 'musgo'
  };

  /* "clip on" no meio da frase ("zeno clip on", "tortoise clip o", "clip om satho") */
  var NA_FRASE = [
    [/\b(?:clip+e?|cli|xlip)\s?(?:on|om|o|pn|9n?)\b|\bclip+on\b/g, 'clip-on'],
    [/\btorrou se\b/g, 'tortoise'],
    [/\bverde oliva\b/g, 'musgo']
  ];

  /* Atalhos: busca exata -> página */
  var ATALHOS = [
    { url: '/pages/multifocal', rotulo: 'Lentes multifocais', k: ['multifocal', 'multifocais', 'lente multifocal', 'lentes multifocais', 'oculos multifocal', 'oculos multifocais', 'multi focal', 'multi fica', 'progressiva', 'progressivas', 'lente progressiva', 'lentes progressivas', 'varilux', 'varilux comfort', 'varilux conforto', 'lente varilux'] },
    { url: '/pages/provador-virtual', rotulo: 'Provador virtual', k: ['provador', 'provador virtual', 'virtual', 'experimentar', 'provar', 'teste virtual', 'provador online', 'provdor', 'provar online', 'experimentar online', 'teste online'] },
    { url: '/collections/favoritos', rotulo: 'Favoritos', k: ['mais vendidos', 'mais vendido', 'best seller', 'best sellers', 'favoritos', 'mais procurados'] },
    { url: '/collections/oculos-de-sol', rotulo: 'Óculos de sol', k: ['oculos de sol', 'sol', 'solar', 'oculos solar', 'oculos escuro', 'oculos escuros'] },
    { url: '/collections/oculos-de-grau', rotulo: 'Óculos de grau', k: ['oculos de grau', 'grau', 'oculos grau', 'armacao', 'armacoes', 'armacao de grau', 'armacoes de grau'] },
    /* Só vale durante a campanha (datas e link vêm da seção "Busca Lahtref: banner" do cabeçalho) */
    { campanha: true, url: '/collections/greenfriday', rotulo: 'Green Friday', k: ['green friday', 'black friday', 'promocao', 'promocoes', 'desconto', 'descontos', 'oferta', 'ofertas', 'sale', 'liquidacao', 'cupom', 'cupons', 'cupom de desconto', 'cupons de desconto'] },
    { url: '/pages/sobre-lentes', rotulo: 'Nossas lentes', k: ['lente', 'lentes', 'lente de grau', 'lentes de grau', 'tipos de lente', 'tipos de lentes', 'antirreflexo', 'anti reflexo', 'antireflexo', 'oculos de grau anti reflexo', 'oculos de grau antirreflexo', 'transition', 'transitions', 'oculos transition', 'oculos de grau transition', 'fotossensivel', 'fotossensiveis', 'filtro azul', 'filtro de luz azul', 'filtro luz azul', 'luz azul', 'blue light', 'monofocal', 'unifocal', 'lente monofocal', 'lente fina', 'lentes finas', 'lente super fina', 'oculos sem grau', 'sem grau', 'hoya'] },
    { url: '/pages/receitas', rotulo: 'Receitas', k: ['receita', 'receitas'] },
    { url: '/pages/medida-de-dp', rotulo: 'Medida de DP', k: ['dp', 'distancia pupilar', 'medida dp', 'medida de dp', 'medir dp'] },
    { url: '/pages/guia-de-tamanhos', rotulo: 'Guia de tamanhos', k: ['tamanho', 'tamanhos', 'guia de tamanhos', 'medidas'] },
    { url: '/pages/rastreio', rotulo: 'Rastrear pedido', k: ['rastreio', 'rastrear', 'rastreamento', 'meu pedido', 'rastrear pedido'] },
    { url: '/collections/acessorios', rotulo: 'Acessórios', k: ['acessorios', 'acessorio', 'estojo', 'estojos', 'kit limpeza', 'kit', 'case', 'travel case', 'porta oculos'] },
    { url: '/pages/contact', rotulo: 'Fale conosco', k: ['atendimento', 'fale conosco', 'fale conosc', 'contato', 'whatsapp', 'suporte', 'ajuda', 'falar com atendente', 'atendimeyo',
      'atacado', 'vendas em atacado', 'venda em atacado', 'revenda', 'plaqueta', 'plaquetas', 'parafuso', 'parafusos'] },
    { url: '/pages/politicas', rotulo: 'Trocas e devoluções', k: ['devolucao', 'devolucoes', 'devolver', 'troca', 'trocas', 'trocar', 'reembolso', 'politica de troca', 'politica devolucao', 'politica de devolucao', 'devoluca', 'politicas'] },
    { url: '/pages/cuidados-gerais', rotulo: 'Garantia e cuidados', k: ['garantia', 'cuidados', 'conserto', 'limpeza'] }
  ];

  /* Medidas digitadas (ex.: "46 22-145", "4920", "22-145"): leva ao guia de tamanhos */
  var GUIA_MEDIDAS = { url: '/pages/guia-de-tamanhos', rotulo: 'Guia de tamanhos', dica: 'Compare as medidas (lente, ponte e haste) com as dos nossos modelos.', k: [] };
  function ehMedida(texto) {
    var t = String(texto || '');
    if (/^(tamanho|medida|medidas) \d{2,3}$/.test(t)) return true; /* "tamanho 47" */
    return /^\d{2,3}([ ]?\d{2,3}){1,2}$/.test(t) || /^\d{4,7}$/.test(t);
  }

  function corrigir(termo) {
    var n = norm(termo);
    if (!n) return String(termo || '').trim();
    if (FRASES[n]) return FRASES[n];
    var mudou = false;
    NA_FRASE.forEach(function (r) {
      var novo = n.replace(r[0], r[1]);
      if (novo !== n) { n = novo; mudou = true; }
    });
    var palavras = n.split(' ').map(function (p) {
      if (PALAVRAS[p] && PALAVRAS[p] !== p) { mudou = true; return PALAVRAS[p]; }
      return p;
    });
    /* gênero não ajuda a busca (modelos unissex): sai do termo, se sobrar alguma palavra */
    var semGenero = palavras.filter(function (p) { return !tem(GENERO, p) && p !== 'em' && p !== 'para' && p !== 'pra'; });
    if (semGenero.length && semGenero.length < palavras.length && palavras.some(function (p) { return tem(GENERO, p); })) { palavras = semGenero; mudou = true; }
    return mudou ? palavras.join(' ') : String(termo).trim();
  }

  /* exato = só busca idêntica; parcial = sugestão enquanto digita (4+ letras) */
  var GENERICAS = ['oculos', 'armacao', 'armacoes', 'modelos', 'lente', 'lentes', 'tipos', 'medida', 'medir', 'meu', 'filtro', 'guia', 'para', 'mais', 'oval'];

  function atalho(termo, parcial) {
    var n = norm(termo);
    if (!n) return null;
    if (parcial && n.indexOf(' ') < 0 && GENERICAS.some(function (g) { return g.indexOf(n) === 0; })) parcial = false;
    for (var i = 0; i < ATALHOS.length; i++) {
      var a = ATALHOS[i];
      if (a.campanha) {
        if (!campanhaAtiva()) continue;
        a = { url: CONFIG.link || a.url, rotulo: a.rotulo, k: a.k };
      }
      for (var j = 0; j < a.k.length; j++) {
        var k = a.k[j];
        if (n === k) return a;
        if (parcial && n.length >= 4 && k.indexOf(n) === 0) return a;
      }
    }
    return null;
  }

  /* ---------- Campanha por data (horário de Brasília) ---------- */
  var CONFIG = {};
  function lerConfig() {
    var el = document.querySelector('[data-lah-busca-config]');
    if (!el) return;
    try { CONFIG = JSON.parse(el.textContent) || {}; } catch (e) { CONFIG = {}; }
  }
  lerConfig();

  function dataBR(txt, fimDoMinuto) {
    var t = String(txt || '').trim();
    if (!t) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) t += fimDoMinuto ? ' 23:59' : ' 00:00';
    var iso = t.replace(' ', 'T');
    if (/T\d{2}:\d{2}$/.test(iso)) iso += fimDoMinuto ? ':59' : ':00';
    if (!/(Z|[+-]\d{2}:?\d{2})$/.test(iso)) iso += '-03:00';
    var d = new Date(iso);
    return isNaN(d.getTime()) ? null : d;
  }

  function agora() {
    var teste = null;
    try {
      teste = new URLSearchParams(location.search).get('lah_data');
      if (teste) sessionStorage.setItem('lah_data', teste);
      else teste = sessionStorage.getItem('lah_data');
    } catch (e) {}
    return (teste && dataBR(teste)) || new Date();
  }

  function campanhaAtiva() {
    if (!CONFIG.inicio && !CONFIG.fim) return false;
    var n = agora(), ini = dataBR(CONFIG.inicio), fim = dataBR(CONFIG.fim, true);
    return (!ini || n >= ini) && (!fim || n <= fim);
  }

  /* ---------- Palavras-chave consultivas ---------- */
  var IGNORAR = ['oculos', 'oculo', 'armacao', 'armacoes', 'modelo', 'modelos', 'de', 'do', 'da', 'dos', 'das', 'para', 'pra',
    'com', 'e', 'o', 'a', 'os', 'as', 'um', 'uma', 'meu', 'minha', 'formato', 'estilo', 'tipo', 'quero', 'procuro',
    'que', 'combina', 'combinam', 'ideal', 'bem', 'mais', 'em', 'no', 'na'];
  /* Todos os modelos Lahtref são unissex: gênero não filtra, só ganha o aviso */
  var GENERO = ['masculino', 'masculina', 'masculinos', 'masculinas', 'feminino', 'feminina', 'femininos', 'femininas',
    'homem', 'homens', 'mulher', 'mulheres', 'mulgeres', 'unissex', 'unisex',
    'mascu', 'mascul', 'masculi', 'masculin', 'maculino', 'maaculino', 'femin', 'femini', 'feminin', 'femininjo'];
  var AVISO_UNISSEX = 'Todos os modelos Lahtref são unissex.';
  var ROSTO = ['rosto', 'rostos', 'rsoto', 'face', 'cara'];
  var SOL = ['sol', 'solar', 'escuro', 'escuros', 'escura'];
  var GRAU = ['grau'];
  var F_REDONDO = ['redondo', 'redonda', 'redondos', 'redondas', 'redondinho', 'redondinha', 'arredondado', 'arredondada', 'arredondados', 'vintage', 'retro', 'lennon'];
  var F_QUADRADO = ['quadrado', 'quadrada', 'quadrados', 'quadradas', 'quadradinho', 'retangular', 'retangulares'];
  var L_LARGO = ['largo', 'larga', 'largos', 'largas', 'grande', 'grandes', 'randes', 'gande'];
  var L_MEDIO = ['medio', 'media'];
  var L_ESTREITO = ['estreito', 'estreita', 'pequeno', 'pequena', 'pequenos', 'pequenas', 'pequrno', 'peeueno', 'pequeko', 'fino', 'fina', 'magro', 'magra'];
  var D_DISCRETO = ['leve', 'leves', 'delicado', 'delicada', 'delicados', 'discreto', 'discreta', 'discretos', 'minimalista', 'sutil'];
  var D_ROBUSTO = ['marcante', 'marcantes', 'robusto', 'robusta', 'robustos', 'grosso', 'grossa', 'grossos', 'encorpado', 'encorpada', 'chamativo', 'chamativa'];

  function tem(lista, p) { return lista.indexOf(p) !== -1; }

  /* Lê buscas só de características ("redondo leve", "rosto largo", "oculos de sol robusto")
     e devolve a coleção já filtrada. Se sobrar qualquer palavra desconhecida (ex.: nome de
     modelo), não interpreta: a busca normal segue. */
  function interpretar(termo) {
    var palavras = norm(termo).split(' ').filter(Boolean);
    if (!palavras.length) return null;
    if (tem(palavras, 'lennon')) palavras = palavras.filter(function (p) { return p !== 'john'; });
    /* Formato/largura depois de "rosto" descrevem o rosto; antes, a armação ("armação redonda pra rosto largo") */
    var posRosto = -1;
    palavras.forEach(function (p, i) { if (posRosto === -1 && tem(ROSTO, p)) posRosto = i; });
    var r = { colecao: 'oculos-de-grau', formato: '', largura: '', destaque: '', dica: '', util: false };
    for (var i = 0; i < palavras.length; i++) {
      var p = palavras[i];
      var rosto = posRosto !== -1 && i > posRosto;
      if (tem(IGNORAR, p) || tem(ROSTO, p)) continue;
      if (tem(GENERO, p)) { r.genero = true; r.util = true; continue; }
      if (tem(SOL, p)) { r.colecao = 'oculos-de-sol'; r.util = true; continue; }
      if (tem(GRAU, p)) { r.colecao = 'oculos-de-grau'; r.util = true; continue; }
      if (rosto && tem(F_REDONDO, p)) { r.formato = 'Quadrado/Retangular'; r.dica = 'Rosto redondo: linhas retas equilibram os traços.'; r.util = true; continue; }
      if (rosto && tem(F_QUADRADO, p)) { r.formato = 'Redondo'; r.dica = 'Rosto quadrado: curvas suavizam os traços.'; r.util = true; continue; }
      if (rosto && p === 'oval') { r.dica = 'Rosto oval: quase todos os formatos combinam.'; r.util = true; continue; }
      if (tem(F_REDONDO, p)) { r.formato = 'Redondo'; r.util = true; continue; }
      if (tem(F_QUADRADO, p)) { r.formato = 'Quadrado/Retangular'; r.util = true; continue; }
      if (tem(L_LARGO, p)) { r.largura = 'Largo'; r.util = true; continue; }
      if (tem(L_MEDIO, p)) { r.largura = 'Médio'; r.util = true; continue; }
      if (tem(L_ESTREITO, p) && (rosto || (p !== 'fino' && p !== 'fina'))) { r.largura = 'Estreito'; r.util = true; continue; }
      if (tem(D_DISCRETO, p)) { r.destaque = 'Discreto'; r.util = true; continue; }
      if (tem(D_ROBUSTO, p)) { r.destaque = 'Robusto'; r.util = true; continue; }
      return null;
    }
    if (!r.util) return null;
    if (r.genero) r.dica = r.dica ? r.dica + ' ' + AVISO_UNISSEX : AVISO_UNISSEX;

    var base = r.colecao === 'oculos-de-sol' ? 'Óculos de sol' : 'Óculos de grau';
    var adj = [];
    if (r.formato) adj.push(r.formato === 'Redondo' ? 'redondos' : 'quadrados ou retangulares');
    if (r.destaque) adj.push(r.destaque === 'Discreto' ? 'discretos' : 'robustos');
    var rotulo = base + (adj.length ? ' ' + adj.join(', ') : '');
    if (r.largura) rotulo += (adj.length ? ', ' : ' ') + 'para rosto ' + r.largura.toLowerCase();

    var q = new URLSearchParams();
    if (r.formato) q.set('formato', r.formato);
    if (r.largura) q.set('largura', r.largura);
    if (r.destaque) q.set('destaque', r.destaque);
    var qs = q.toString().replace(/%2F/g, '/');
    return { url: '/collections/' + r.colecao + (qs ? '?' + qs : '') + '#produtos', rotulo: rotulo, dica: r.dica, filtros: r };
  }

  function temGenero(termo) { return norm(termo).split(' ').some(function (p) { return tem(GENERO, p); }); }
  var UNISSEX = { url: '/collections/oculos-de-grau', rotulo: 'Óculos de grau', dica: AVISO_UNISSEX, k: [] };

  function destino(termo, parcial) {
    return interpretar(termo) || atalho(termo, parcial) || (ehMedida(norm(termo)) ? GUIA_MEDIDAS : null);
  }


  function escapar(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function htmlAtalho(a, n) {
    var conta = typeof n === 'number' ? ' (' + n + (n === 1 ? ' modelo' : ' modelos') + ')' : '';
    return '<a class="lah-busca-atalho" href="' + a.url + '">' +
      '<span>Ir para <strong>' + escapar(a.rotulo) + '</strong>' + escapar(conta) +
      (a.dica ? '<span class="lah-busca-atalho__dica">' + escapar(a.dica) + '</span>' : '') + '</span>' +
      '<svg aria-hidden="true" focusable="false" width="8" height="12" viewBox="0 0 8 12"><path fill="none" stroke="currentColor" stroke-width="1.5" d="M1.5 1l5 5-5 5"/></svg></a>';
  }

  /* Quantos modelos a coleção filtrada mostra (mesma regra dos Filtros Lahtref) */
  var TAGS_FILTRO = { 'Redondo': ['redondo'], 'Quadrado/Retangular': ['quadrado', 'retangular'], 'Estreito': ['estreito'], 'Médio': ['médio'], 'Largo': ['largo'], 'Discreto': ['discreto'], 'Robusto': ['robusto'] };
  function contarFiltro(f) {
    var lista = dados && dados[f.colecao];
    if (!lista) return null;
    return lista.filter(function (p) {
      return ['formato', 'largura', 'destaque'].every(function (g) {
        if (!f[g]) return true;
        return (TAGS_FILTRO[f[g]] || []).some(function (t) { return p.tags.indexOf(t) !== -1; });
      });
    }).length;
  }

  /* ---------- Busca preditiva ---------- */
  function ajustarGaveta() {
    var Gaveta = window.customElements && customElements.get('predictive-search-drawer');
    if (!Gaveta || Gaveta.prototype.__lahBusca) return;
    Gaveta.prototype.__lahBusca = true;

    Gaveta.prototype._doPredictiveSearch = async function (termo) {
      /* Busca só de características ("rosto redondo", "redondo leve"): a resposta é a
         coleção já filtrada, sem lista de produtos que poderia contradizer a dica */
      var interp = interpretar(termo);
      if (interp) {
        var n = contarFiltro(interp.filtros);
        if (n === null) { var pr = carregarDados(); if (pr) { await pr; n = contarFiltro(interp.filtros); } }
        return { hasResults: true, html: htmlAtalho(interp, n) };
      }
      var q = corrigir(termo);
      var url = URL_SUGESTAO + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,query' +
        '&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag' +
        '&section_id=predictive-search';
      var resposta = await fetch(url, { signal: this.abortController.signal });
      var div = document.createElement('div');
      div.innerHTML = await resposta.text();
      var temResultados = div.querySelector('.predictive-search__results-categories') !== null;
      var html = div.firstElementChild ? div.firstElementChild.innerHTML : '';

      var a = atalho(termo, true) || (ehMedida(norm(termo)) ? GUIA_MEDIDAS : null) || (temGenero(termo) ? UNISSEX : null);
      if (a) {
        var link = htmlAtalho(a, null);
        html = temResultados ? link + html : link;
        temResultados = true;
      }
      return { hasResults: temResultados, html: html };
    };
  }

  if (window.customElements) {
    if (customElements.get('predictive-search-drawer')) ajustarGaveta();
    else customElements.whenDefined('predictive-search-drawer').then(ajustarGaveta);
  }

  /* ---------- Chips "Mais buscados" ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-lah-busca-termo]');
    if (!chip) return;
    var gaveta = chip.closest('predictive-search-drawer');
    var campo = gaveta && gaveta.querySelector('[name="q"]');
    if (!campo) return;
    e.preventDefault();
    campo.value = chip.getAttribute('data-lah-busca-termo');
    campo.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    campo.focus();
  });

  /* ---------- Envio do formulário ---------- */
  function ehFormBusca(f) {
    if (!f || f.tagName !== 'FORM') return false;
    var acao = (f.getAttribute('action') || '').split('?')[0].replace(/\/$/, '');
    return /\/search$/.test(acao) && !!f.querySelector('[name="q"]');
  }

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!ehFormBusca(f)) return;
    var bruto = f.querySelector('[name="q"]').value;
    if (!norm(bruto)) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var a = destino(bruto, false);
    if (a) { window.location.href = a.url; return; }

    var params = new URLSearchParams();
    params.set('q', corrigir(bruto));
    params.set('type', 'product');
    window.location.href = URL_BUSCA + '?' + params.toString();
  }, true);

  /* ---------- Banner da gaveta (campanha ou padrão) ---------- */
  function mostrarBanner() {
    lerConfig();
    /* Os banners vêm da seção do cabeçalho (template) e entram na gaveta uma vez */
    var alvo = document.querySelector('[data-lah-busca-banners-alvo]');
    var modelo = document.querySelector('template[data-lah-busca-banners]');
    if (alvo && modelo && !alvo.children.length) alvo.appendChild(modelo.content.cloneNode(true));
    var ativa = campanhaAtiva();
    document.querySelectorAll('[data-lah-banner]').forEach(function (b) {
      b.hidden = (b.getAttribute('data-lah-banner') === 'campanha') !== ativa;
    });
  }

  /* ---------- Filtro guiado "Encontre seu modelo" ---------- */
  var FAIXAS_FILTRO = [10, 15, 20, 30, 40, 50, 60]; /* mesmas faixas e tolerância dos Filtros Lahtref */
  function faixa(d) {
    if (!d) return 0;
    var perto = 0, menor = 999, abaixo = 0;
    FAIXAS_FILTRO.forEach(function (f) { var x = Math.abs(d - f); if (x <= 2 && x < menor) { menor = x; perto = f; } });
    if (perto) return perto;
    FAIXAS_FILTRO.forEach(function (f) { if (f <= d && f > abaixo) abaixo = f; });
    return abaixo;
  }

  var dados = null, carregando = null;
  function carregarDados() {
    if (dados || carregando) return carregando;
    carregando = fetch('/?section_id=lah-busca-dados')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        var el = div.querySelector('[data-lah-busca-dados]');
        dados = el ? JSON.parse(el.textContent) : {};
        Object.keys(dados).forEach(function (c) {
          dados[c].forEach(function (p) { p.tags = (p.t || []).map(function (t) { return String(t).toLowerCase(); }); p.f = faixa(p.d); });
        });
      })
      .catch(function () { dados = null; carregando = null; });
    return carregando;
  }

  function iniciarGuia(raiz) {
    var guia = raiz.querySelector('[data-lah-guia]');
    if (!guia || guia.__lah) return;
    guia.__lah = true;
    var ver = guia.querySelector('[data-lah-guia-ver]');
    var estado = { colecao: 'oculos-de-grau', largura: '', formato: '', destaque: '', desconto: '' };

    /* Faixas de desconto da campanha (só durante a campanha) */
    var linhaDesc = guia.querySelector('[data-lah-guia-desconto]');
    var faixasCfg = String(CONFIG.faixas || '').split(/[^0-9]+/).filter(Boolean).map(Number);
    if (linhaDesc && campanhaAtiva() && faixasCfg.length) {
      guia.querySelector('[data-lah-guia-faixas]').innerHTML = faixasCfg.map(function (f) {
        return '<button type="button" class="lah-guia__op" data-valor="' + f + '" aria-pressed="false">' + f + '% off</button>';
      }).join('');
      var rotuloDesc = guia.querySelector('[data-lah-guia-desconto-rotulo]');
      if (rotuloDesc && CONFIG.titulo) rotuloDesc.textContent = CONFIG.titulo;
      linhaDesc.hidden = false;
    }

    function produtos() { return dados && dados[estado.colecao] ? dados[estado.colecao] : null; }
    function tagsDe(btn) { return (btn.getAttribute('data-tags') || '').split(',').filter(Boolean); }
    function botaoSel(grupo) {
      return estado[grupo] ? guia.querySelector('[data-grupo="' + grupo + '"] [data-valor="' + estado[grupo] + '"]') : null;
    }
    function passa(p, ignorar) {
      return ['largura', 'formato', 'destaque', 'desconto'].every(function (g) {
        if (g === ignorar || !estado[g]) return true;
        if (g === 'desconto') return String(p.f) === estado[g];
        var b = botaoSel(g);
        return !b || tagsDe(b).some(function (t) { return p.tags.indexOf(t) !== -1; });
      });
    }
    function contarCom(grupo, valor, btn) {
      var lista = produtos();
      if (!lista) return null;
      return lista.filter(function (p) {
        if (!passa(p, grupo)) return false;
        if (grupo === 'desconto') return String(p.f) === valor;
        return tagsDe(btn).some(function (t) { return p.tags.indexOf(t) !== -1; });
      }).length;
    }

    function atualizar() {
      guia.querySelectorAll('[data-grupo]').forEach(function (linha) {
        var g = linha.getAttribute('data-grupo');
        linha.querySelectorAll('[data-valor]').forEach(function (b) {
          var v = b.getAttribute('data-valor');
          var marcado = estado[g] === v;
          b.setAttribute('aria-pressed', marcado ? 'true' : 'false');
          if (g === 'colecao') return;
          var n = contarCom(g, v, b);
          b.setAttribute('aria-disabled', n === 0 && !marcado ? 'true' : 'false');
          if (g === 'desconto') b.hidden = n === 0 && !marcado;
        });
      });

      var q = new URLSearchParams();
      ['formato', 'largura', 'destaque', 'desconto'].forEach(function (g) { if (estado[g]) q.set(g, estado[g]); });
      var qs = q.toString().replace(/%2F/g, '/');
      ver.href = '/collections/' + estado.colecao + (qs ? '?' + qs : '') + '#produtos';

      var lista = produtos(), algum = !!qs;
      var nome = estado.colecao === 'oculos-de-sol' ? 'óculos de sol' : 'óculos de grau';
      if (!lista) {
        ver.textContent = algum ? 'Ver modelos' : 'Ver ' + nome;
        ver.removeAttribute('aria-disabled');
        return;
      }
      var n = lista.filter(function (p) { return passa(p); }).length;
      if (n === 0) {
        ver.textContent = 'Nenhum modelo nessa combinação';
        ver.setAttribute('aria-disabled', 'true');
      } else {
        ver.textContent = algum ? 'Ver ' + n + (n === 1 ? ' modelo' : ' modelos') : 'Ver todos os ' + nome + ' (' + n + ')';
        ver.removeAttribute('aria-disabled');
      }
    }

    guia.addEventListener('click', function (e) {
      var b = e.target.closest('[data-valor]');
      if (!b || !guia.contains(b)) return;
      if (b.getAttribute('aria-disabled') === 'true') return;
      var g = b.closest('[data-grupo]').getAttribute('data-grupo');
      var v = b.getAttribute('data-valor');
      if (g === 'colecao') estado.colecao = v;
      else estado[g] = estado[g] === v ? '' : v;
      atualizar();
    });

    atualizar();
    var p = carregarDados();
    if (p) p.then(atualizar);
    guia.__atualizar = atualizar;
  }

  function prepararGaveta() {
    var gaveta = document.getElementById('search-drawer');
    if (!gaveta) return;
    mostrarBanner();
    iniciarGuia(gaveta);
    if (gaveta.__lahObs) return;
    gaveta.__lahObs = true;
    new MutationObserver(function () {
      if (!gaveta.hasAttribute('open')) return;
      mostrarBanner();
      var p = carregarDados();
      var guia = gaveta.querySelector('[data-lah-guia]');
      if (p && guia && guia.__atualizar) p.then(guia.__atualizar);
    }).observe(gaveta, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepararGaveta);
  else prepararGaveta();


  /* O XCloud reescreve a ação dos formulários para /a/search: devolve para a busca nativa */
  function restaurarAcao() {
    document.querySelectorAll('form[action$="/a/search"]').forEach(function (f) {
      f.setAttribute('action', URL_BUSCA);
    });
  }
  restaurarAcao();
  document.addEventListener('DOMContentLoaded', restaurarAcao);
  window.addEventListener('load', function () { restaurarAcao(); setTimeout(restaurarAcao, 1500); });

  /* Atalhos da busca levam a /collections/...#produtos: sem âncora com esse id na página,
     rola até a barra de filtros, logo acima dos produtos */
  function rolarParaProdutos() {
    if (location.hash !== '#produtos' || document.getElementById('produtos')) return;
    var alvo = document.querySelector('lah-filtros:not([hidden]), .product-facet__meta-bar, .product-facet');
    if (!alvo) return;
    var y = alvo.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top: Math.max(0, y) });
  }
  window.addEventListener('load', function () { setTimeout(rolarParaProdutos, 350); });

  window.lahBusca = { corrigir: corrigir, atalho: atalho, interpretar: interpretar, campanhaAtiva: campanhaAtiva, norm: norm };
})();
